const ROTATE_TIMER_S = 10;
const ROTATE_TIMER_MS = ROTATE_TIMER_S * 1000;

const createVideoHtml = (idx, video, withPoster) => {
  const posterUrl = withPoster
    ? `poster="/wp-content/themes/dreamtheme-child/src/mov/${video}.jpg"`
    : "";
  return `<video class="video-component item-${idx}" muted playsinline ${posterUrl}>
 <source src="/wp-content/themes/dreamtheme-child/src/mov/${video}.webm" type="video/webm">
 <source src="/wp-content/themes/dreamtheme-child/src/mov/${video}.mp4" type="video/mp4">
 <img src="/wp-content/themes/dreamtheme-child/src/mov/${video}.jpg" alt="" />
 </video>`;
};

const inView = (element, inViewType) => {
  var viewport = {};
  viewport.top = jQuery(window).scrollTop();
  viewport.bottom = viewport.top + jQuery(window).height();
  var bounds = {};
  bounds.top = element.offset().top;
  bounds.bottom = bounds.top + element.outerHeight();
  switch (inViewType) {
    case "bottomOnly":
      return bounds.bottom <= viewport.bottom && bounds.bottom >= viewport.top;
    case "topOnly":
      return bounds.top <= viewport.bottom && bounds.top >= viewport.top;
    case "both":
      return bounds.top >= viewport.top && bounds.bottom <= viewport.bottom;
    default:
      return bounds.top >= viewport.top && bounds.bottom <= viewport.bottom;
  }
};

const initializeCountdown = (numItems, activeItem, wrapper) => {
  const resetCircularCountdown = (container) => {
    const countdownContainer = jQuery(container)[0];
    const progressWrapper = jQuery("svg", countdownContainer)[0];

    progressWrapper.style.strokeDasharray = 0;
    progressWrapper.style.animation = null;
  };

  const initializeCircularCountdown = (container) => {
    const countdownContainer = jQuery(container)[0];
    const progressWrapper = jQuery("svg", countdownContainer)[0];
    const progress = jQuery("svg circle", countdownContainer)[0];
    let length = progress.getTotalLength();
    progressWrapper.style.strokeDasharray = length;
    progressWrapper.style.animation = `circular-progress-animation linear ${ROTATE_TIMER_S}s forwards`;
  };

  const wrapperClassSelector = `.circular-progress-wrapper.${
    window.innerWidth > 745 ? "full-form" : "small-format"
  }`;

  for (let idx = 1; idx <= numItems; idx++) {
    if (idx == activeItem) {
      jQuery(`.nav-item-${idx} ${wrapperClassSelector}`, wrapper).each(
        (idx, el) => initializeCircularCountdown(el)
      );
    } else {
      setTimeout(() => {
        jQuery(`.nav-item-${idx} ${wrapperClassSelector}`, wrapper).each(
          (idx, el) => resetCircularCountdown(el)
        );
      }, 1000);
    }
  }
};

const initiateItemScroller = (wrapper) => {
  const numItems = parseInt(wrapper.data("num-items"));

  let nextRotationTime;
  const rotateElement = (goToItem) => {
    nextRotationTime = new Date().getTime() + ROTATE_TIMER_MS;
    if (wrapper.length) {
      const activeItem = parseInt(wrapper.data("active-item"));
      let nextItem = activeItem + 1;
      if (nextItem > numItems) nextItem = 1;
      if (goToItem) {
        nextItem = goToItem;
      }

      wrapper.removeClass(`active-item-${activeItem}`);
      wrapper.addClass(`active-item-${nextItem}`);
      wrapper.data("active-item", nextItem);
      initializeCountdown(numItems, nextItem, wrapper);

      const activeVideoComponent = jQuery(
        `.video-component.item-${nextItem}`,
        wrapper
      );

      if (activeVideoComponent.length) {
        activeVideoComponent[0].currentTime = 0;
        activeVideoComponent[0].play();
      }
    }
  };

  let tickerTimerId;
  const timerTick = () => {
    if (tickerTimerId) clearTimeout(tickerTimerId);

    // const now = new Date().getTime();
    // const percent = 100 * ((nextRotationTime - now) / ROTATE_TIMER_MS);
    // const degrees = Math.round(percent * 3.6);
    // jQuery(".circular-progress", wrapper).css(
    //   "--loader-progress",
    //   `${Math.round(360 - degrees)}deg`
    // );

    // Rotate elements
    // if (percent <= 0) {
    // }

    rotateElement();
    tickerTimerId = setTimeout(timerTick, ROTATE_TIMER_MS);
  };

  jQuery(".lazyload-video", wrapper).each((idx, el) => {
    if (!jQuery(el).data("isloaded")) {
      jQuery(el).data("isloaded", true);
      const itemId = jQuery(el).data("idx");
      jQuery(el).html(createVideoHtml(itemId, jQuery(el).data("video")));
    }
  });

  let animationStarted = false;
  const triggerScrollEvent = () => {
    if (animationStarted) return;
    if (inView(jQuery(".items-scroller-headers", wrapper))) {
      animationStarted = true;
      // rotateElement(0);
      timerTick(); // Start the clock
    }
  };
  jQuery(document).on("scroll", triggerScrollEvent);
  triggerScrollEvent();

  // Only rotate if there is more than one item
  if (numItems > 1) {
    jQuery("video", wrapper).each((idx, video) => {
      video.currentTime = 0;
    });

    jQuery(".nav-btn-item", wrapper)
      .unbind("click")
      .bind("click", (el) => {
        const _this = el.currentTarget;
        const item = jQuery(_this).data("idx");
        rotateElement(parseInt(item));
      });
  }
};

const initiateAllItemScroller = () => {
  jQuery(".unifon-text-items-scroller").each((idx, item) => {
    initiateItemScroller(jQuery(item));
  });
};

export default initiateAllItemScroller;
